import styled from 'styled-components';
var CONTAINER_LEFT_OFFSET = '-60px';
var Container = styled.div.withConfig({
  displayName: "ToggleBlockEditToolbarstyle__Container",
  componentId: "sc-gqmp4r-0"
})(["position:absolute;right:", ";display:flex;align-items:center;height:40px;cursor:pointer;"], CONTAINER_LEFT_OFFSET);
export { Container };